import localKey from './localKey'
import commonConfig from './common.js'
import {useApiUrl} from './url.js'


export default {
  ...commonConfig,
  ...localKey,
  apiUrl: useApiUrl,
  siteName: '远健卓实教育管理后台',
  siteUrl: "yjzsedu.com",
  minSiteMame: 'CSM',
  platformUUID:'POMP',
  // fileGetUrl: "https://v.yjzsedu.com/",
  fileGetUrl:"https://mediadev.yjzsedu.com/",
  // 上传文件目录
  imgDir: "study/question/platform",
  videoDir: "study/question/platform",
  audioDir: "study/question/platform",
}
